import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table text-left w-full" }
const _hoisted_2 = { class: "table-cell pb-x2 pr-20 w-300 whitespace-nowrap" }
const _hoisted_3 = { class: "table-cell" }
const _hoisted_4 = { class: "table-cell text-right" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "px-5 bg-brandy inline-block cursor-default"
}

import { ClickAndCollectStoreInventoryResult } from '@/storecontext/shared/api/server-apis';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketDeliverableStoreSelection',
  props: {
    storesStatus: null,
    selectedId: { default: undefined },
    selectLabel: { default: undefined },
    selectedLabel: { default: undefined }
  },
  emits: ['select'],
  setup(__props: any, { emit }) {

const props = __props as { storesStatus: ClickAndCollectStoreInventoryResult[], selectedId: string, selectLabel: string, selectedLabel: string }






const select = (status: ClickAndCollectStoreInventoryResult): void => {
    emit('select', status);
};

const isSelected = (status: ClickAndCollectStoreInventoryResult): boolean => {
    return status.storeId === props.selectedId;
};

const isItemsAvailable = (status: ClickAndCollectStoreInventoryResult): boolean => {
    return (status.itemIdsAvailable?.length > 0 ?? false);
};

const isSelectable = (status: ClickAndCollectStoreInventoryResult): boolean => {
    return isItemsAvailable(status) && !isSelected(status);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dl", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.storesStatus, (store) => {
      return (_openBlock(), _createElementBlock("div", {
        key: store.storeId,
        class: "table-row"
      }, [
        _createElementVNode("dt", _hoisted_2, _toDisplayString(store.storeTitle), 1),
        _createElementVNode("dd", _hoisted_3, [
          _createVNode(BlockLabelWithNamedArguments, {
            label: store.status,
            class: _normalizeClass({'text-silver': !isItemsAvailable(store)})
          }, null, 8, ["label", "class"])
        ]),
        _createElementVNode("dd", _hoisted_4, [
          (isSelectable(store))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "c-magic-line c-magic-line--underline text-dusty-grey",
                onClick: ($event: any) => (select(store))
              }, _toDisplayString(__props.selectLabel), 9, _hoisted_5))
            : (isSelected(store))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.selectedLabel), 1))
              : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}
}

})